var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "informationOverlay",
      staticClass: "information-overlay",
      class: {
        active:
          !_vm.instagramReplyMode && (_vm.status || _vm.isReplyingToComment),
      },
    },
    [
      !_vm.instagramReplyMode && !_vm.showingInstagramCommentButtons
        ? _c(
            "div",
            { staticClass: "description" },
            [
              _vm.status === "enter-join" ? _c("EnterSvg") : _vm._e(),
              _vm._v(" "),
              _vm.status === "enter-create" ? _c("EnterSvg") : _vm._e(),
              _vm._v(" "),
              _vm.status === "inactive"
                ? _c("div", { staticClass: "material-icons" }, [
                    _vm._v("block"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.status === "deactive-user"
                ? _c("div", { staticClass: "material-icons" }, [_vm._v("chat")])
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.statusText[_vm.status]))]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.instagramReplyMode &&
      _vm.channelStatus &&
      !_vm.showingInstagramCommentButtons
        ? _c("div", [
            ["enter-join", "enter-create"].includes(_vm.status)
              ? _c(
                  "div",
                  { staticClass: "button-group" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.clickButton },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.joinText()) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.status === "enter-create" &&
                    _vm.isWhatsapp &&
                    _vm.whatsappChannels.length > 1
                      ? _c("SupsisButton", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { followCursor: false, placement: "top" },
                              expression:
                                "{ followCursor: false, placement: 'top' }",
                            },
                          ],
                          attrs: {
                            content: _vm.$t(
                              "message.startChatWithDifferentChannel"
                            ),
                            icon: "swap_horiz",
                            square: "",
                            ghost: "",
                          },
                          on: { click: _vm.startWhatsappChat },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canToggleAnswerStatus
                      ? _c("SupsisButton", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { followCursor: false, placement: "top" },
                              expression:
                                "{ followCursor: false, placement: 'top' }",
                            },
                          ],
                          attrs: {
                            content: _vm.answerStatusButtonText,
                            icon: _vm.answerStatusIcon,
                            square: "",
                            ghost: "",
                            loading: _vm.markingAsAnswered,
                          },
                          on: { click: _vm.toggleAnswerStatus },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.instagramReplyMode &&
      ["deactive-user"].includes(_vm.status) &&
      _vm.isWhatsapp &&
      !_vm.showingInstagramCommentButtons
        ? _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.sendTemplateMessage } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.sendTemplateMessage")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.instagramReplyMode && _vm.showingInstagramCommentButtons
        ? _c("div", { staticClass: "instagram-comment-buttons" }, [
            _c(
              "div",
              { staticClass: "button-row" },
              [
                !_vm.isLastCommentRepliedViaDM
                  ? _c(
                      "SupsisButton",
                      {
                        attrs: {
                          primary: "",
                          disabled: _vm.isLastCommentDeleted,
                        },
                        on: { click: _vm.replyCommentAsDM },
                      },
                      [_vm._v("\n                DM'den Yanıtla\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { ghost: "", disabled: _vm.isLastCommentDeleted },
                    on: { click: _vm.replyComment },
                  },
                  [_vm._v("\n                Yorumu Yanıtla\n            ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.contact.platform === "instagram"
              ? _c(
                  "div",
                  { staticClass: "button-row" },
                  [
                    !_vm.isLastCommentDeleted
                      ? _c(
                          "SupsisButton",
                          {
                            attrs: { ghost: "" },
                            on: { click: _vm.toggleHideComment },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.isLastCommentHidden
                                    ? "Yorumu Göster"
                                    : "Yorumu Gizle"
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isLastCommentDeleted
                      ? _c(
                          "SupsisButton",
                          {
                            attrs: { ghost: "", danger: "" },
                            on: { click: _vm.deleteComment },
                          },
                          [_vm._v("\n                Yorumu Sil\n            ")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isLastCommentDeleted
              ? _c("div", { staticClass: "comment-deleted-warning" }, [
                  _vm._v("\n            ⚠️ Bu yorum silindi\n        "),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.instagramReplyMode &&
      ["deactive-user"].includes(_vm.status) &&
      _vm.isInstagramOrMessenger &&
      !_vm.isReplyingToComment &&
      !_vm.isLastMessageComment &&
      _vm.hasLastMessageTS
        ? _c("div", { staticClass: "instagram-waiting-message" }, [
            _c("span", [_vm._v(_vm._s(_vm.instagramWaitingMessage))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              staticClass: "modal-wp-chat-starter",
              attrs: {
                "show-footer": false,
                title: _vm.$t("message.whatsappChatStarter"),
              },
              on: {
                cancel: function () {
                  return (_vm.showWhatsappChatStarterModal = false)
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.contact.whatsappNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-email": _vm.contact.email,
                  "default-name": _vm.contact.name || _vm.contact.fullname,
                },
                on: {
                  close: function () {
                    return (_vm.showWhatsappChatStarterModal = false)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }